import { useEmbedBootstrap } from '../use-widget-bootstrap';
import { useWidgetSeo } from '../widget-hooks/use-widget-seo';
import { TrainerManageSlotsSection } from './trainer_TrainerManageSlotsSection';

export default function TrainerWorkSchedulePage() {
  useWidgetSeo(
    'Рабочий график | Кабинет тренера',
    'Управление рабочим графиком тренера и слотами тренировок.'
  );
  const { widgetContour, hasPermission } = useEmbedBootstrap();
  const trainerMobile = widgetContour === 'trainer-mobile';
  const trainerMobileLayout = trainerMobile ? ('week' as const) : null;
  const canStaffScheduleWrite = hasPermission('schedule:staff_write');

  return (
    <div className="w-full min-w-0 space-y-4">
      <TrainerManageSlotsSection
        heading="Рабочий график"
        description="Ваши занятия в выбранном филиале на две недели: создание, изменение и перенос. Удалять занятия можно, если администратор выдал такое право."
        trainerMobileLayout={trainerMobileLayout}
        canStaffScheduleWrite={canStaffScheduleWrite}
      />
    </div>
  );
}
